import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface ExternalLinkIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const ExternalLinkIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: ExternalLinkIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M16.917 12.8195V17.7365C16.917 18.1712 16.7443 18.5881 16.4369 18.8954C16.1296 19.2028 15.7127 19.3755 15.278 19.3755H6.26351C5.82882 19.3755 5.41193 19.2028 5.10456 18.8954C4.79719 18.5881 4.62451 18.1712 4.62451 17.7365V8.72201C4.62451 8.28732 4.79719 7.87043 5.10456 7.56306C5.41193 7.25569 5.82882 7.08301 6.26351 7.08301H11.1805"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.4585 4.62451H19.3755V9.5415"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 12L19.3755 4.62451"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ExternalLinkIcon
